/**
 * MILA BABY — Colour Group Swatches
 * Fetches sibling products by colour-group tag
 * Swaps product section in-place via Shopify sections API
 * Reads colour name from Color/Colour variant option
 * Renders colour dot swatches grouped by colour-type tag
 */

(function () {
  'use strict';

  var _memCache = {};
  var CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

  // ── Hex map — add new colours here as you expand ──
  var HEX_MAP = {
    'blue mist':  '#D5E1EA',
    'blush':      '#FFEAEF',
    'sage':       '#C2D8CE',
    'twilight':   '#B8A9C9'
  };

  function getHex(colourName) {
    if (!colourName) return '#CCCCCC';
    return HEX_MAP[colourName.toLowerCase()] || '#CCCCCC';
  }

  function previewParam() {
    var match = window.location.search.match(/[?&](preview_theme_id=[^&]+)/);
    return match ? '&' + match[1] : '';
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function findProductSection() {
    var el = document.querySelector('[data-section-type="product"]');
    if (!el) {
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) el = form.closest('[id^="shopify-section-"]');
    }
    if (!el) {
      // Dawn theme fallback
      el = document.querySelector('product-info');
      if (el) el = el.closest('[id^="shopify-section-"]');
    }
    if (!el) return null;
    var sectionId = el.dataset.sectionId || el.id.replace(/^shopify-section-/, '');
    return { el: el, sectionId: sectionId };
  }

  function sessionGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (Date.now() - entry.ts > CACHE_TTL_MS) {
        sessionStorage.removeItem(key);
        return null;
      }
      return entry.data;
    } catch (e) { return null; }
  }

  function sessionSet(key, val) {
    try {
      sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: val }));
    } catch (e) {}
  }

  // ── Swap product section in-place ──
  window.__milaSwapProduct = async function (url) {
    // Theme editor (design mode): the editor re-syncs section state and
    // clobbers an in-place swap — navigate instead so the preview follows.
    if (window.Shopify && window.Shopify.designMode) {
      window.location.assign(url);
      return;
    }

    var found = findProductSection();
    if (!found) { window.location.assign(url); return; }

    var section  = found.el;
    var sectionId = found.sectionId;

    section.style.opacity = '0.4';
    section.style.pointerEvents = 'none';
    section.style.transition = 'opacity 0.15s';

    try {
      var sep  = url.indexOf('?') !== -1 ? '&' : '?';
      var fetchUrl = url + sep + 'sections=' + encodeURIComponent(sectionId) + previewParam();

      var resp = await fetch(fetchUrl);
      if (!resp.ok) throw new Error('HTTP ' + resp.status);

      var data = await resp.json();
      var html = data[sectionId];
      if (!html) throw new Error('Section key missing');

      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var newSection = tmp.firstElementChild;
      if (!newSection) throw new Error('Empty section HTML');

      newSection.style.opacity = '0';
      newSection.style.transition = 'opacity 0.2s';

      section.parentNode.replaceChild(newSection, section);
      history.replaceState({}, document.title, url);

      // Re-run inline scripts
      newSection.querySelectorAll('script:not([src])').forEach(function (s) {
        var t = (s.type || '').toLowerCase();
        if (t && t !== 'text/javascript') return;
        var ns = document.createElement('script');
        ns.textContent = s.textContent;
        s.parentNode.replaceChild(ns, s);
      });

      document.dispatchEvent(new CustomEvent('shopify:section:load', {
        bubbles: true,
        detail: { sectionId: sectionId }
      }));

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          newSection.style.opacity = '';
          newSection.style.transition = '';
        });
      });

    } catch (err) {
      console.warn('mila-colour-swatches: swap failed:', err.message);
      window.location.assign(url);
    }
  };

  // ── Fetch products by tag ──
  async function fetchAllByTag(tag) {
    var all = [];
    var page = 1;
    var limit = 250;
    while (true) {
      var url = '/products.json?tag=' + encodeURIComponent(tag) + '&limit=' + limit + '&page=' + page + previewParam();
      var resp = await fetch(url);
      if (!resp.ok) break;
      var data = await resp.json();
      var batch = data.products || [];
      all = all.concat(batch);
      if (batch.length < limit) break;
      page++;
      if (page > 10) break;
    }
    return all;
  }

  // ── Get colour name from variant option ──
  function getColourFromVariant(product) {
    for (var i = 0; i < product.options.length; i++) {
      var name = product.options[i].name.toLowerCase();
      if (name === 'color' || name === 'colour') {
        var vals = product.options[i].values;
        return vals && vals[0] ? vals[0] : '';
      }
    }
    return '';
  }

  // ── Get colour-type from tags ──
  function getColourType(product) {
    for (var i = 0; i < product.tags.length; i++) {
      if (product.tags[i].indexOf('colour-type:') === 0) {
        return product.tags[i].replace('colour-type:', '');
      }
    }
    return 'core';
  }

  // ── Main component ──
  function MilaColourSwatches(el) {
    this.el = el;
    this.colourGroup = decodeURIComponent(el.dataset.colourGroup);
    this.productHandle = el.dataset.productHandle;
    this.inner = el.querySelector('.mila-colour-group__inner');
    this.fetchAndRender();
  }

  MilaColourSwatches.prototype.fetchAndRender = async function () {
    var self = this;
    var colourGroup = this.colourGroup;
    // Try both capitalizations since Shopify may store with capital C
    var exactTag = 'colour-group:' + colourGroup;
    var exactTagCap = 'Colour-group:' + colourGroup;
    var cacheKey = 'mila_cg_' + colourGroup;

    if (_memCache[cacheKey]) { self.render(_memCache[cacheKey]); return; }

    var cached = sessionGet(cacheKey);
    if (cached && cached.length) {
      _memCache[cacheKey] = cached;
      self.render(cached);
      return;
    }

    try {
      // Fetch using capitalised tag (how Shopify stored it)
      var allProducts = await fetchAllByTag(exactTagCap);
      if (!allProducts.length) {
        allProducts = await fetchAllByTag(exactTag);
      }
      // Filter case insensitive
      var products = allProducts.filter(function (p) {
        return p.tags.some(function (t) {
          return t.toLowerCase() === exactTag.toLowerCase() ||
                 t.toLowerCase() === exactTagCap.toLowerCase();
        });
      });

      var swatches = products.map(function (p) {
        var colour = getColourFromVariant(p);
        var colourType = getColourType(p);
        return {
          handle: p.handle,
          url: '/products/' + p.handle,
          colour: colour,
          colourType: colourType,
          hex: getHex(colour)
        };
      });

      _memCache[cacheKey] = swatches;
      sessionSet(cacheKey, swatches);
      self.render(swatches);
    } catch (e) {
      console.warn('mila-colour-swatches: fetchAndRender error:', e);
    }
  };

  MilaColourSwatches.prototype.render = function (swatches) {
    var self = this;

    // Group by colour-type
    var groups = {};
    var groupOrder = [];

    swatches.forEach(function (s) {
      var key = s.colourType || 'core';
      if (!groups[key]) { groups[key] = []; groupOrder.push(key); }
      groups[key].push(s);
    });

    // Core first
    var coreIdx = groupOrder.indexOf('core');
    if (coreIdx > 0) {
      groupOrder.splice(coreIdx, 1);
      groupOrder.unshift('core');
    }

    var hasMultipleGroups = groupOrder.length > 1;
    var html = [];

    groupOrder.forEach(function (groupKey, idx) {
      var items = groups[groupKey];
      if (!items || !items.length) return;

      // Only show group label if there are multiple groups
      if (hasMultipleGroups) {
        var label = groupKey.charAt(0).toUpperCase() + groupKey.slice(1);
        html.push('<span class="mila-swatch-group-label">' + escapeHtml(label) + '</span>');
      }

      html.push('<div class="mila-colour-swatches" style="margin-bottom:' + (hasMultipleGroups && idx < groupOrder.length - 1 ? '8px' : '0') + ';">');

      items.forEach(function (s) {
        var isActive = s.handle === self.productHandle;
        var title = escapeHtml(s.colour || s.handle);

        html.push(
          '<button type="button"' +
          ' class="mila-swatch' + (isActive ? ' mila-swatch--active' : '') + '"' +
          ' data-url="' + escapeHtml(s.url) + '"' +
          ' onclick="window.__milaSwapProduct(this.dataset.url)"' +
          ' title="' + title + '"' +
          ' aria-label="' + title + '"' +
          (isActive ? ' aria-current="true" disabled' : '') +
          ' style="background-color:' + escapeHtml(s.hex) + ';">' +
          '</button>'
        );
      });

      html.push('</div>');
    });

    if (!html.length) {
      self.el.style.display = 'none';
      return;
    }

    self.el.style.display = '';
    self.inner.innerHTML = html.join('');

    // Update colour label
    var currentSwatch = swatches.find(function (s) { return s.handle === self.productHandle; });
    if (currentSwatch) {
      var label = self.el.querySelector('.mila-colour-current');
      if (label) label.textContent = currentSwatch.colour;
    }
  };

  // ── Init ──
  function initSwatches() {
    document.querySelectorAll('.mila-colour-group:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '');
      new MilaColourSwatches(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwatches);
  } else {
    initSwatches();
  }

  document.addEventListener('shopify:section:load', function () {
    initSwatches();
  });

})();